// @flow
import styled from 'styled-components';

export const Errors = styled.ul`color: ${props => props.theme.error};`;

export const Error = styled.li`margin-bottom: 1em;`;



// WEBPACK FOOTER //
// ./src/components/widgets/errors/styles.js